import React from 'react';
import StatisticsSectionsSections from '../../components/UFO/statistics/index';  // ✅ Fix import

const StatisticsSectionsPage = () => {
  return (
    <>
      <StatisticsSectionsSections />  {/* ✅ Fix component usage */}
    </>
  );
};

export default StatisticsSectionsPage;